export default __webpack_public_path__ + "static/media/loupe.672df7c6.svg";